var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-xmark",
    clipPath: "url(#clip0_5674_33252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M5 1.4375C6.07744 1.4375 7.11075 1.86551 7.87262 2.62738C8.63449 3.38925 9.0625 4.42256 9.0625 5.5C9.0625 6.57744 8.63449 7.61075 7.87262 8.37262C7.11075 9.13449 6.07744 9.5625 5 9.5625C3.92256 9.5625 2.88925 9.13449 2.12738 8.37262C1.36551 7.61075 0.9375 6.57744 0.9375 5.5C0.9375 4.42256 1.36551 3.38925 2.12738 2.62738C2.88925 1.86551 3.92256 1.4375 5 1.4375ZM5 10.5C6.32608 10.5 7.59785 9.97322 8.53553 9.03553C9.47322 8.09785 10 6.82608 10 5.5C10 4.17392 9.47322 2.90215 8.53553 1.96447C7.59785 1.02678 6.32608 0.5 5 0.5C3.67392 0.5 2.40215 1.02678 1.46447 1.96447C0.526784 2.90215 0 4.17392 0 5.5C0 6.82608 0.526784 8.09785 1.46447 9.03553C2.40215 9.97322 3.67392 10.5 5 10.5ZM3.41797 3.91797C3.23438 4.10156 3.23438 4.39844 3.41797 4.58008L4.33594 5.49805L3.41797 6.41602C3.23438 6.59961 3.23438 6.89648 3.41797 7.07812C3.60156 7.25977 3.89844 7.26172 4.08008 7.07812L4.99805 6.16016L5.91602 7.07812C6.09961 7.26172 6.39648 7.26172 6.57812 7.07812C6.75977 6.89453 6.76172 6.59766 6.57812 6.41602L5.66016 5.49805L6.57812 4.58008C6.76172 4.39648 6.76172 4.09961 6.57812 3.91797C6.39453 3.73633 6.09766 3.73438 5.91602 3.91797L4.99805 4.83594L4.08008 3.91797C3.89648 3.73438 3.59961 3.73438 3.41797 3.91797Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5674_33252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveIcon);
export default __webpack_public_path__ + "static/media/deactive-icon.5bed93246b785c9386ba034174009259.svg";
export { ForwardRef as ReactComponent };